module.exports = __webpack_public_path__ + "static/media/guide-girl.fb477859.png";